<mat-card class="exercise-management-card" *ngIf="exercise() as exercise; else loading">
  <mat-card-header>
    <mat-card-title>{{exercise.title | capitalize}}</mat-card-title>
    <a mat-button [routerLink]="['/courses/'+exercise.lesson.course.id+'/lessons/'+exercise.lesson.id+'/exercises/' + exercise.id + '/edit']" color="primary">
      Edit
    </a>
  </mat-card-header>
  <mat-card-content class="exercise-details">
    <mat-card-subtitle class="student">Course</mat-card-subtitle>
    <a [routerLink]="['/courses/'+exercise.lesson.course.id+'/edit']">
      {{exercise.lesson.course.title}}
    </a>

    <mat-card-subtitle class="student">Subject</mat-card-subtitle>
    <p>{{exercise.subject}}</p>

    <mat-card-subtitle class="student">Lesson</mat-card-subtitle>
    <a [routerLink]="['/courses/'+exercise.lesson.course.id+'/lessons/'+exercise.lesson.id+'/edit']">
      {{exercise.lesson.title}}
    </a>

    <mat-card-subtitle class="student">Description</mat-card-subtitle>
    <p>{{exercise.description}}</p>

    <ng-container *ngIf="exercise.introCopy && exercise.introCopy.length > 0">
      <mat-card-subtitle class="student">Introduction copy</mat-card-subtitle>
      <p>{{exercise.introCopy}}</p>
    </ng-container>

    <!-- TODO: Add to data model -->
      <mat-card-subtitle class="student">Video Link</mat-card-subtitle>
      <p>{{exercise.videoLink}}</p>

    <!-- TODO: Add to data model -->
    <ng-container *ngIf="exercise.showOpenAnswerEnabled === 1">
      <mat-card-subtitle class="student">Open Answer Prompt</mat-card-subtitle>
      <p>{{exercise.openAnswerPrompt}}</p>
    </ng-container>

    <ng-container *ngIf="exercise.completeCopy && exercise.completeCopy.length > 0">
      <mat-card-subtitle class="student">Complete content</mat-card-subtitle>
      <p>{{exercise.completeCopy}}</p>
    </ng-container>

    <mat-card-subtitle class="student">Pacing Goal (Total Minutes)</mat-card-subtitle>
    <p>{{exercise.pacingGoal}}</p>

    <mat-card-subtitle class="student">Accuracy Goal (Percent Correct)</mat-card-subtitle>
    <p>{{exercise.accuracyGoal}}</p>
  </mat-card-content>
  <section class="problems-section">
    <!--Problems-->
    <app-problem-list [problems]="exercise.problems" [showPagination]="false"></app-problem-list>
    <!--End of Problems-->
  </section>
</mat-card>

<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
